<template>
<div class="proposed-deal">
	<p>
		<span class="key">Block Owner:</span>
		<span class="value">Petroperu</span>
	</p>
	<p>
		<span class="key">Block Interest</span>
		<span class="value"></span>
	</p>
	<p>
		<span class="key">Available:</span>
		<span class="value">35%</span>
	</p>
	<p>
		<span class="key">Terms:</span>
		<span class="value">
			Fund 43.75% of the cost of the first exploration well, capped at US$27.5 million (at 100%)
		</span>
	</p>
	<p>
		<span class="key">Unrisked prospective resource (gross):</span>
		<span class="value">256 mmbbls</span>
	</p>
	<p>
		<span class="key">Unrisked prospective resource (net):</span>
		<span class="value">102 mmbbls</span>
	</p>
	<p>
		<span class="key">Follow-on opportunity:</span>
		<span class="value">Yes</span>
	</p>
</div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
.proposed-deal {
	text-align: left;
	color: #fff;
	font-weight: 200;
	padding-right: 60px !important;
	line-height: 17px;
	
	p {
		font-size: 13px;
	}
	.key {
		font-weight: 600;
		margin-right: 3px;
	}
}
</style>
